import { createActions, createReducer } from 'reduxsauce'

import FuncaoService from '../servicos/FuncaoDespesaService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaDespesaInicio: [],
    buscaDespesaSucesso: ['despesa'],
    buscaDespesaErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaDespesas = exercicio => {
    return dispatch => {
        dispatch(Creators.buscaDespesaInicio())
        let serv = new FuncaoService()
        return serv
            .getDespesas(exercicio)
            .then(response => dispatch(Creators.buscaDespesaSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaDespesaErro(error)))
    }
}

const buscaDespesaInicio = (state = INITIAL_STATE, action) => {
    return { ...state, carregando: true, erro: null }
}

const buscaDespesaErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaDespesaSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.despesa, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_DESPESA_INICIO]: buscaDespesaInicio,
    [Types.BUSCA_DESPESA_ERRO]: buscaDespesaErro,
    [Types.BUSCA_DESPESA_SUCESSO]: buscaDespesaSucesso,
})
